import styles from './Upload.module.scss';
import { useDropzone } from 'react-dropzone';
import { useAppDispatch } from '../../../store/hooks';
import { deleteMedia, uploadMedia } from '../../../store/coctailsSlice';
import { message } from 'antd';
import cln from 'classnames';
import { useState } from 'react';
import { Loader } from '../../../components';
import { API_URL } from '../../../lib/api/index';

export interface IUpload {
  type: 'image' | 'video' | 'audio';
  withDeleteButton?: boolean;
  value?: string | null;
  acceptFile?: { [key: string]: string[] };
  setValue: (value: string) => void;
  onToggleDisabled?: (value: boolean) => void;
}

const Upload = (props: IUpload) => {
  const {
    type,
    withDeleteButton = false,
    value,
    setValue,
    acceptFile = {
      'image/jpeg': ['.jpeg'],
    },
    onToggleDisabled,
  } = props;
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const visibleDeleteButton = withDeleteButton && !!value;

  const onDrop = async (acceptedFiles: any) => {
    onToggleDisabled?.(true);
    setLoading(true);
    if (!!acceptedFiles?.length) {
      for (const file of acceptedFiles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'type',
          type === 'image' ? 'image' : type === 'video' ? 'content' : 'audio',
        );
        const response = await dispatch(uploadMedia(formData));
        message.success(
          type === 'image'
            ? 'Image uploaded successfully!'
            : type === 'video'
            ? 'Video uploaded successfully!'
            : 'Audio uploaded successfully!',
        );
        setValue(response.payload.data.fileName);
        onToggleDisabled?.(false);
      }
    }
    setLoading(false);
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: acceptFile,
    onDrop: acceptedFiles => {
      onDrop(acceptedFiles);
    },
  });

  const onDelete = async () => {
    onToggleDisabled?.(true);
    setLoadingDelete(true);
    await dispatch(
      deleteMedia({
        name: value,
        type: type === 'image' || type === 'audio' ? type : 'content',
      }),
    );
    setValue(null);
    setLoadingDelete(false);
  };

  return (
    <div
      className={cln(styles.container, {
        [styles.container_withValue]: !!value,
        [styles.container_isAudio]: type === 'audio',
      })}
    >
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {!value && !loading && (
          <div className={styles.label}>
            {type === 'image'
              ? 'Сlick to add a picture...'
              : type === 'video'
              ? 'Сlick to add a video...'
              : 'Сlick to add a audio...'}
          </div>
        )}
        {loading && <Loader size={40} />}
      </div>
      {!!value && (
        <div key={value}>
          {type === 'image' ? (
            <img src={`${API_URL}/storage/image/${value}`} />
          ) : type === 'video' ? (
            <video controls>
              <source src={`${API_URL}/storage/content/${value}`} />
              Your browser does not support the video tag.
            </video>
          ) : (
            <audio controls src={`${API_URL}/storage/audio/${value}`}></audio>
          )}
          {visibleDeleteButton && !loadingDelete ? (
            <div className={styles.actionBtn} onClick={onDelete} />
          ) : (
            <div className={styles.spin}>
              <Loader />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Upload;
